import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/maze-discover-cover.webp";
import CrazyIFrame from 'src/components/CrazyIFrame';


export const projectDetails: ProjectInterface = {
    url: "maze-discover",
    title: "Maze Discover",
    summary: "Dig through mazes and find treasures.",
    description: `My contributions to the game Maze Discover were basically revolved around porting the web version of the game. I adjusted gameplay mechanics to ensure smooth functionality in the web environment, making necessary tweaks to optimize the player experience. I also helped the art team to adjust the UI to suit the web platform, ensuring seamless navigation and interaction for players. 

To facilitate the porting process, I created tools specifically for the port of the web version. Furthermore, I integrated SDKs and external tools essential for web-based gaming.`,
    year: "2022",
    tags: ["Adventure", "Idle Arcade", "WebGL", "Unity"],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    videoSrc: "",
    isCoverType: false,
    haveTags: true,
    projectType: ProjectType.PROFESSIONAL,
    roles: ["Programmer"],
    studio: ["Izyplay Game Studio"],
    technologies: ["Unity", "C#", "WebGL"],
    platforms: ["Web"],
    collaborators: ["[link=Izyplay Game Studio|https://izyplay.com.br/]"],
    highlightColor: "#60151F",
    descriptionTitle: "",
    linkData: [
        { type: 'text', url: "https://www.crazygames.com/game/maze-discover" },
    ],
    relatedProjects: ["IzasSupermarket", "SpookyIsland", "CheckMore"],
};


export function MazeDiscover() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                leftContent={
                    <div className="a-left-no-bg">
                        <CrazyIFrame src="https://www.crazygames.com/embed/maze-discover" height={500} title="Maze Discover" />
                    </div>
                }
                rightContent={
                    null
                }>
            </ProjectBase>
        </div>
    );
}